import { Controller } from "stimulus"

export default class extends Controller {

  urlChange(event) {
    document.getElementById("title_"+event.currentTarget.dataset.id).value = event.currentTarget.dataset.title;
    document.getElementById("url_"+event.currentTarget.dataset.id).value = event.currentTarget.dataset.url;
    document.getElementById("author_"+event.currentTarget.dataset.id).value = event.currentTarget.dataset.author;
    document.getElementById("content_type_"+event.currentTarget.dataset.id).value = event.currentTarget.dataset.content;
    // $('#content_type_'+event.currentTarget.dataset.id+' option[value="'+event.currentTarget.dataset.content+'"]').prop('selected', true);
    $('.fr-view').html(event.currentTarget.dataset.body);
    setTimeout(function(){
      $('.link-select-modal').modal('hide');
      toastr.info('Content form updated. Complete the form and click save.');
    }, 300);
  }
}
